<template>
	<div class="aboutDiv">
		<!-- banner -->
		<div class="banner">
			<img src="../../assets/img/aboutBanner.png" alt="">
		</div>
		<!-- main -->
		<div class="main" v-show="newsListShow">
			<!-- 公司介绍 -->
			<div class="introduce" id="introduce">
				<div class="homeTitle">
					<div class="homeTitleText">公司介绍</div>
					<div class="homeTitleLine"></div>
				</div>
				<div class="introduceCon">
					<div class="introduceConText">
						<p>
							&nbsp;&nbsp;&nbsp;上海煜豆信息科技有限公司成立于2017年。公司是初具规模的成长型企业，集行业知识、工程实践、先进技术于一体，作为信息化整体方案解决的服务商，围绕建设工程领域及相关行业，以专业应用为核心基础，深度融合行业应用的前沿技术，快速响应客户的变化需求，着力打造信息大数据时代建设工程管理与服务新模式，致力于技术创新和商业模式创新，为政府管理和企业用户提供先进、可靠、安全、高质量、易扩展的应用定制解决方案和产品工程解决方案，以及相关软硬件产品、平台及服务。
						</p>
						<p>
							&nbsp;&nbsp;&nbsp;公司秉承“为社会创造效益、为客户创造价值、为企业创造财富”的经营理念，恪守“专注专业、追求卓越”的企业精神，奉行“知人善任、人尽其才，才尽其用”的人才理念，通过开放式创新、卓越运营管理、人力资源发展等战略的实施，以一流的服务、一流的技术和一流的品质，全面打造公司的核心竞争力，使公司通过互联网的自由、平等、开拓与创新精神，以平台化理念打造产业链生态体系，以行业的信息化为支撑，成就优秀的行业品牌，提供有价值的行业服务，力争成为国内领先的数字建筑平台服务商。
						</p>
					</div>
					<!-- <div class="introduceConImg">
						<img src="../../assets/img/4.webp" alt="">
					</div> -->
				</div>
				<div id="divss"></div>
			</div>
			<!-- 企业文化 -->
			<div class="culture" id="culture">
				<div class="homeTitle">
					<div class="homeTitleText">企业文化</div>
					<div class="homeTitleLine"></div>
				</div>
				<div class="cultureCon" id="cultureCon">
					<el-carousel indicator-position="outside">
						<el-carousel-item>
							<div class="cultureConDiv">
								<div class="cultureConDivItem">
									<p class="title">企业精神</p>
									<i class="line"></i>
									<p class="desc">
										以“专注专业，追求卓越”的企业精神，力争成为国内领先的数字建筑平台服务商
									</p>
								</div>
								<div class="cultureConDivItem">
									<p class="title">经营理念</p>
									<i class="line"></i>
									<p class="desc">
										以“为社会创造效益，为客户创造价值，为企业创造财富”的经营理念，持续提升产业先进性与领导力，领跑产业发展
									</p>
								</div>
								<div class="cultureConDivItem">
									<p class="title">
										企业目标
									</p>
									<i class="line"></i>
									<p class="desc">
										将信息科技融入中国建造，为工程建设提供整体化解决方案，在环境与发展之间构建可持续的价值
									</p>
								</div>
								<div class="cultureConDivItem">
									<p class="title">企业愿景</p>
									<i class="line"></i>
									<p class="desc">
										以网络信息技术为支点，打造国内领先的智慧建筑服务平台
									</p>
								</div>
							</div>
						</el-carousel-item>
						<el-carousel-item>
							<div class="cultureConDiv">
								<div class="cultureConDivItem">
									<p class="title">核心价值</p>
									<i class="line"></i>
									<p class="desc">
										以“成就客户，高效敬业，诚信正直，追求卓越”的核心价值，在创新中寻求发展，在合作中共赢
									</p>
								</div>
								<div class="cultureConDivItem">
									<p class="title">企业作风</p>
									<i class="line"></i>
									<p class="desc">
										以“务实创新、认真负责、解决问题、创造价值”的企业作风，改进和提升企业的管理水平
									</p>
								</div>
								<div class="cultureConDivItem">
									<p class="title">
										经营哲学
									</p>
									<i class="line"></i>
									<p class="desc">
										以“持续创新，互利共赢”经营理念，提升企业的凝聚力
									</p>
								</div>
								<!-- <div class="cultureConDivItem" style="opacity: 0;">
								</div> -->
							</div>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div id="cultureConss"></div>
			</div>

			<!-- 社会责任 -->
			<div class="society" id="society">
				<div class="homeTitle">
					<div class="homeTitleText">社会责任</div>
					<div class="homeTitleLine"></div>
				</div>
				<div class="societyCon">
					<ul class="auCSR-list" id="auCSR-list">
						<li>
							<div class="auCSR-box">
								<div class="name">以效益为中心</div>
								<i class="icon"></i>
								<img src="../../assets/img/society1.jpg" alt="">
							</div>
							<div class="auCSR-con">
								<div class="auCSR-tb">
									<div class="auCSR-td">
										<div class="name">以效益为中心</div>
										<div class="split"></div>
										<div class="con">
											企业创造效益是生存的之本，为企业创造效益是员工的职责。企业经营的中心任务永远是获取效益，企业健康发展、创造效益，才能承担社会责任，才能进一步为社会创造更多价值，解决就业、员工福利、纳税等来履行社会责任。
										</div>
									</div>
								</div>
							</div>
						</li>
						<li>
							<div class="auCSR-box">
								<div class="name">
									以市场为导向
								</div>
								<i class="icon"></i>
								<img src="../../assets/img/society2.jpg" alt="">
							</div>
							<div class="auCSR-con">
								<div class="auCSR-tb">
									<div class="auCSR-td">
										<div class="name">
											以市场为导向
										</div>
										<div class="split"></div>
										<div class="con">
											企业的产品必须满足客户需求，企业的发展必须适应市场的变化，企业的前进方向必须符合行业发展预期。高度重视产品和服务的质量及标准，持续提升满足客户需求的能力和市场竞争能力是企业以市场为导向之纲领。
										</div>
									</div>
								</div>
							</div>
						</li>
						<li>
							<div class="auCSR-box">
								<div class="name">
									视人才为根本
								</div>
								<i class="icon"></i>
								<img src="../../assets/img/society3.jpg" alt="">
							</div>
							<div class="auCSR-con">
								<div class="auCSR-tb">
									<div class="auCSR-td">
										<div class="name">
											视人才为根本
										</div>
										<div class="split"></div>
										<div class="con">
											企业创造效益需要由员工来实现，企业把创造效益的员工视为企业的宝贵财富和重要资源，为成就客户、高效敬业、诚信正直、追求卓越的员工提供其实现人生更大价值的舞台，鼓励与企业共成长、共发展，并给予相应的回报。
										</div>
									</div>
								</div>
							</div>
						</li>
						<li>
							<div class="auCSR-box">
								<div class="name">
									以业绩论英雄
								</div>
								<i class="icon"></i>
								<img src="../../assets/img/society4.jpg" alt="">
							</div>
							<div class="auCSR-con">
								<div class="auCSR-tb">
									<div class="auCSR-td">
										<div class="name">
											以业绩论英雄
										</div>
										<div class="split"></div>
										<div class="con">
											业绩是企业经营结果的体现，是评价企业发展关键的指标。企业把业绩作为体现社会价值、企业价值和员工价值的结合点。通过科学合理的指标考核，形成企业在市场上以业绩论成败，员工在企业中以业绩论奖惩，激励企业和员工提高工作效率，从而提升公司的整体业绩。
										</div>
									</div>
								</div>
							</div>
						</li>
						<li>
							<div class="auCSR-box">
								<div class="name">
									积极承担社会责任
								</div>
								<i class="icon"></i>
								<img src="../../assets/img/society5.jpg" alt="">
							</div>
							<div class="auCSR-con">
								<div class="auCSR-tb">
									<div class="auCSR-td">
										<div class="name">
											积极承担社会责任
										</div>
										<div class="split"></div>
										<div class="con">
											以务实创新、认真负责、解决问题、创造价值方式开展业务，致力于持续拓展与政府和行业合作伙伴和供应商等的平等对话，充分尊重利益相关者的合法权利，并与他们积极合作，共同推进公司持续、健康地发展，共同构建绿色的智慧平台，以“网络信息技术为支点，打造国内领先的智慧建筑服务平台”的战略，坚持以做大做强国产建筑软件为己任，走专、精、特、新的企业发展之路，为实现企业报国、科技报国的使命努力奋斗，承担和履行应有社会责任。
										</div>
									</div>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
			<!-- 荣誉资质 -->
			<div class="honour" id="honour">
				<div class="homeTitle">
					<div class="homeTitleText">荣誉资质</div>
					<div class="homeTitleLine"></div>
				</div>
				<div class="honourCon">
					<!-- for循环开始 -->
					<div class="honourConImg">
						<img src="../../assets/img/honour1.png" alt="">
					</div>
					<div class="honourConImg">
						<img src="../../assets/img/honour2.png" alt="">
					</div>
					<div class="honourConImg">
						<img src="../../assets/img/honour3.png" alt="">
					</div>
					<div class="honourConImg">
						<img src="../../assets/img/honour3.png" alt="">
					</div>
					<div class="honourConImg">
						<img src="../../assets/img/honour2.png" alt="">
					</div>
					<div class="honourConImg">
						<img src="../../assets/img/honour1.png" alt="">
					</div>
					<div class="honourConImg">
						<img src="../../assets/img/honour1.png" alt="">
					</div>
					<div class="honourConImg">
						<img src="../../assets/img/honour1.png" alt="">
					</div>
					<!-- for循环结束 -->
				</div>
			</div>
		</div>
		<!-- 引入新闻列表组件 -->
		<newsList ref="newsList" v-show="!newsListShow"></newsList>
	</div>
</template>
<script>
	import newsList from './modules/newsList.vue'
	export default {
		components: {
			newsList
		},
		data() {
			return {
				newsListShow: true //当newsListShow为true时，新闻列表隐藏，否则显示
			};
		},
		created() {
			document.documentElement.scrollTop = 0;
		},
		mounted() {
			let pointIdName = this.$route.query.pointIdName
			this.newsListShow = true
			if (pointIdName != undefined && pointIdName != 'newsList') {
				this.goRule(pointIdName)
			} else if (pointIdName == 'newsList') {
				this.newsListShow = false
			}
			//社会责任js部分
			var aa = document.getElementsByClassName('auCSR-con')[0]
			var bb = document.getElementsByClassName('auCSR-tb')[0]
			aa.addEventListener('mouseenter', function () {
				aa.style.width = '720px'
				if (aa.style.width == '720px') {
					console.log('11111111111')
				}
			})
		},
		methods: {
			//锚点跳转
			goRule(event) {
				let id = "#" + event;
				console.log(document.querySelector(id), "document.querySelector(id)")
				document.querySelector(id).scrollIntoView({
					behavior: "smooth",
					block: "center",
					inline: "nearest",
				}, true);
			},
		},
	}
</script>
<style scoped lang="scss">
	.ones {
		width: 720px;
		height: 100%;
		background-color: gray;
	}

	/*滚动条样式*/
	.con::-webkit-scrollbar {
		width: 4.5px; //纵向滚动条的宽度
	}

	.con::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.15);
		background: rgba(0, 0, 0, 0.08);
	}

	.con::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.15);
		border-radius: 0;
		background: rgba(0, 0, 0, 0.08);
	}

	/*滚动条样式*/
	.aboutDiv {
		width: 100%;

		.banner {
			width: 100%;
			height: 450px;
			margin-bottom: 45px;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.introduce,
		.honour,
		.society {
			width: 65%;
			margin: 0 auto;
		}

		// 标题开始
		.homeTitle {
			width: 100%;
			text-align: center;
			margin: 0 auto;
			margin-bottom: 35px;

			.homeTitleText {
				height: 45px;
				font-size: 31px;
				color: #000;
				font-weight: 500;
				// padding: 60px 0 8px 0;
				padding: 30px 0 8px 0;
			}

			.homeTitleLine {
				width: 64px;
				height: 3px;
				background: #006fff;
				margin: 0 auto;
			}
		}

		// 标题结束

		// 公司介绍开始*************
		.introduce {
			.introduceCon {
				height: 350px;
				position: relative;
				margin-top: -50px;
				/* margin-bottom: 0px; */

				.introduceConText {
					position: absolute;
					height: 60%;
					margin-top: 20px;
					/* top: 5%; */
					/* width: 65%; */
					/* border: 1.5px solid #5CB5F4; */
					/* box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2); */
					z-index: 9;
					/* border-radius: 10px; */
					padding: 30px;
					/* background: rgba(255, 255, 255, 0.6); */
					/* margin-bottom: 30px; */

					p {
						font-size: 20px;
						// line-height: 30px;
						line-height: 26px;
						/* color: #999999; */
						color: black;
						text-indent: 28px;
					}
				}

				.introduceConImg {
					position: absolute;
					height: 100%;
					width: 40%;
					left: 60%;
					box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);

					img {
						width: 100%;
						height: 100%;
					}
				}
			}
		}

		// 公司介绍结束*************
		// 企业文化开始*************
		.culture {
			background: papayawhip;
			height: 400px;
			width: 100%;
			background-image: url(../../assets/img/beijing1.png);
			background-repeat: no-repeat;
			background-size: cover;
			margin-bottom: 60px;

			.homeTitleText {
				color: #fff;
			}

			.homeTitleLine {
				background: #fff;
			}

			.cultureCon {
				width: 65%;
				// height: 65%;
				margin: 0 auto;

				.cultureConDiv {
					width: 100%;
					height: 100%;
					display: flex;
					flex-direction: row;
					justify-content: flex-start;

					.cultureConDivItem {
						width: 22%;
						margin: 0 1.2%;
						border-radius: 6px;
						// padding: 30px 35px 20px;
						border: 1px solid #fff;
						color: #fff;

						.title {
							text-align: center;
							font-size: 18px;
							line-height: 18px;
							width: 85%;
							margin: 0 auto;
							margin-top: 30px;
						}

						.line {
							display: block;
							width: 22px;
							height: 3px;
							background-color: #fff;
							margin: 18px auto 0;
							// transition: all 0.3s;
						}

						.desc {
							// width: 100%;
							width: 85%;
							margin: 0 auto;
							margin-top: 15px;
							font-size: 14px;
							line-height: 30px;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 4; // 想要超出三行显示 就把这里改成3就好了
						}
					}
				}
			}
		}

		.cultureConDiv>div:nth-child(1) {
			margin-left: 2.4% !important;
		}

		.cultureConDivItem:hover {
			background: rgba(255, 255, 255, 0.95);
			cursor: pointer;

			.title {
				color: #207be6;
			}

			.line {
				background-color: #207be6 !important;
			}

			.desc {
				color: #207be6;
			}
		}

		.culture /deep/ .el-carousel__container {
			height: 240px;
			margin-bottom: 6px;
		}

		.culture /deep/ .el-carousel__indicators--horizontal {
			// display: none;
		}

		.culture /deep/ .el-carousel__indicator button {
			background-color: #fff;
		}

		.culture /deep/ .el-carousel__button {
			width: 32px;
			height: 3px;
			border-radius: 2px;
		}

		.culture /deep/ .el-carousel__indicators--outside .el-carousel__indicator:hover button {
			opacity: 1
		}

		.culture /deep/ .el-carousel__arrow {
			display: none;
		}

		.culture /deep/ .el-carousel__item:nth-child(2n+1) {
			background: none;
		}

		// 企业文化结束*************
		// 荣誉资质开始*************
		.honour {
			margin-bottom: 60px;

			.honourCon {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				margin-left: -35px;

				.honourConImg {
					width: 24%;
					height: 180px;
					margin: 0 0.5%;
					margin-bottom: 20px;

					img {
						width: 100%;
						height: 100%;
					}
				}
			}
		}

		// 荣誉资质结束*************
		// 社会责任开始*************
		.society {
			margin-bottom: 85px;

			.societyCon {
				height: 450px;

				.auCSR-list {
					width: 1200px;
					display: flex;
					flex-direction: row;
					margin-left: 30px;
				}

				.auCSR-list li {
					width: 240px;
					position: relative;
					display: flex;
					flex-direction: row;
					z-index: 2;
					overflow: hidden;
					// overflow: visible;
				}

				.auCSR-list .auCSR-box {
					overflow: hidden;
					position: relative;
					z-index: 5;
				}

				.auCSR-box:before,
				.auCSR-box:after {
					content: "";
					display: block;
					/* width: 100%; */
					width: 240px;
					height: 50%;
					background: rgba(0, 0, 0, .4);
					position: absolute;
					left: 0px;
				}

				.auCSR-box:before {
					top: 0px;
				}

				.auCSR-box:after {
					bottom: 0px;
				}

				.auCSR-box .name {
					width: 70%;
					text-align: center;
					padding: 15px 0;
					line-height: 34px;
					font-size: 20px;
					color: #fff;
					border-top: 1px solid rgba(255, 255, 255, .4);
					border-bottom: 1px solid rgba(255, 255, 255, .4);
					position: absolute;
					top: 120px;
					left: 50%;
					transform: translateX(-50%);
					-webkit-transform: translateX(-50%);
					z-index: 2;
				}

				.auCSR-box .icon {
					display: block;
					width: 60px;
					height: 60px;
					position: absolute;
					left: 50%;
					bottom: 150px;
					margin-left: -30px;
					z-index: 2;
				}

				.auCSR-list li:nth-child(1) .auCSR-box .icon {
					background: url(../../assets/img/societyIcon1.png) no-repeat center center / cover;
				}

				.auCSR-list li:nth-child(2) .auCSR-box .icon {
					background: url(../../assets/img/societyIcon2.png) no-repeat center center / cover;
				}

				.auCSR-list li:nth-child(3) .auCSR-box .icon {
					background: url(../../assets/img/societyIcon3.png) no-repeat center center / cover;
				}

				.auCSR-list li:nth-child(4) .auCSR-box .icon {
					background: url(../../assets/img/societyIcon4.png) no-repeat center center / cover;
				}

				.auCSR-list li:nth-child(5) .auCSR-box .icon {
					background: url(../../assets/img/societyIcon5.png) no-repeat center center / cover;
				}

				.auCSR-box {
					width: 240px;
					height: 500px;
				}

				.auCSR-box>img {
					width: 240px;
					height: 100%;
				}

				.auCSR-con {
					width: 240px;
					height: 100%;
					background: rgba(255, 255, 255, 0.78);
					position: absolute;
					top: 0px;
					opacity: 0;
					z-index: 1000;
				}

				.auCSR-con .auCSR-tb {
					/* width: 100%; */
					width: 240px;
					height: 100%;
					overflow: hidden;
					position: absolute;
					top: 0px;
					left: 0px;
				}

				.auCSR-tb .auCSR-td {
					padding: 20px;
					vertical-align: middle;
				}

				.auCSR-td .name {
					line-height: 40px;
					font-size: 22px;
					color: #222;
					margin-top: 35px;
				}

				.auCSR-td .split {
					display: block;
					width: 31px;
					height: 1px;
					background: #e50012;
					margin: 10px 0 20px;
				}

				.auCSR-td .con {
					line-height: 22px;
					font-size: 15px;
					color: #666666;
					/* overflow: hidden; */
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 9;
				}

				.auCSR-box:before,
				.auCSR-box:after,
				.auCSR-box .name,
				.auCSR-box .icon,
				.auCSR-con {
					transition: all .6s ease-in-out;
					-webkit-transition: all .6s ease-in-out;
				}

				.auCSR-list li:hover .auCSR-box:before {
					top: -100%;
					opacity: 0;
					transition-delay: .2s;
					-webkit-transition-delay: .2s;
				}

				.auCSR-list li:hover .auCSR-box:after {
					bottom: -100%;
					opacity: 0;
					transition-delay: .2s;
					-webkit-transition-delay: .2s;
				}

				.auCSR-list li:hover .auCSR-box .name {
					top: -100px;
					opacity: 0;
				}

				.auCSR-list li:hover .auCSR-box .icon {
					transform: translateY(100px);
					-webkit-transform: translateY(100px);
					opacity: 0;
				}

				.auCSR-list li:hover {
					z-index: 5;
					cursor: pointer;
				}

				.auCSR-list li:hover .auCSR-con {
					opacity: 1;
					z-index: 5;
				}
			}
		}

		// 社会责任结束*************
	}
</style>